import { BrowserRouter, Routes, Route } from "react-router-dom";

import Nav from './components/Nav';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

import HomePage from './pages/HomePage';
import CoursesPage from './pages/CoursesPage';
import CoursePage from './pages/CoursePage';
import SyllabusPage from './pages/SyllabusPage';
import DemoPage from './pages/DemoPage';
import RegistrationPage from './pages/RegistrationPage';
import FeesPage from './pages/FeesPage';
import AboutPage from './pages/AboutPage';
import CareersPage from './pages/CareersPage';
import ContactPage from './pages/ContactPage';

export default function App() {
  return (
    <BrowserRouter>
      <Nav />

      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/courses" element={<CoursesPage />} />
          <Route path="/python" element={<CoursePage course="python" />} />
          <Route path="/webdev" element={<CoursePage course="webdev" />} />
          <Route path="/msoffice" element={<CoursePage course="msoffice" />} />
          <Route path="/syllabus" element={<SyllabusPage />} />
          <Route path="/demo" element={<DemoPage />} />
          <Route path="/register" element={<RegistrationPage />} />
          <Route path="/registration" element={<RegistrationPage />} />
          <Route path="/fees" element={<FeesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </main>

      <Footer />
      <WhatsAppButton />
    </BrowserRouter>
  );
}
